/**
 * Helpers pour afficher et saisir la durée en heures + minutes (stockage API en minutes).
 */

export function minutesToHoursMinutes(
  totalMinutes: number | null | undefined
): { hours: number; minutes: number } {
  if (totalMinutes == null || totalMinutes <= 0 || !Number.isFinite(totalMinutes)) {
    return { hours: 0, minutes: 0 };
  }
  const m = Math.round(Number(totalMinutes));
  return {
    hours: Math.floor(m / 60),
    minutes: m % 60,
  };
}

export function hoursMinutesToMinutes(hours: number, minutes: number): number {
  const h = Number.isFinite(hours) ? Math.max(0, Math.floor(Number(hours))) : 0;
  const m = Number.isFinite(minutes) ? Math.max(0, Math.min(59, Math.floor(Number(minutes)))) : 0;
  return h * 60 + m;
}

/** Pour les inputs durée : pas de valeur par défaut "0", on garde le champ vide (placeholder visible). */
export function durationInputValue(n: number): string {
  return n === 0 ? '' : String(n);
}

/**
 * Formate une durée en minutes pour l'affichage (stats, listes, etc.) en heures.
 * Ex. 80 → "1h20", 45 → "45min", 0 ou null → "–"
 */
export function formatDurationMinutesToHours(minutes: number | null | undefined): string {
  if (minutes == null || minutes <= 0 || !Number.isFinite(minutes)) return '–';
  const m = Math.round(Number(minutes));
  const hours = Math.floor(m / 60);
  const mins = m % 60;
  if (hours > 0) {
    return mins > 0 ? `${hours}h${mins}` : `${hours}h`;
  }
  return `${mins}min`;
}
